<template>
  <v-container fluid class="pa-0">
    <v-row no-gutters v-show="!editMode">
      <AddressList :CustomerId="Customer.Id" :closable="false" ref="AddressList" showEdit
        @New="edit({ CustomerId: Customer.Id, IsActive: true })" @Edit="e => edit(e)"> <!-- @Select="setAddress" -->
      </AddressList>
    </v-row>
    <v-row no-gutters v-show="editMode" >
      <AddressEdit :key="editKey" :CustomerId="Customer.Id" :Address="editObject" 
        @Created="setAddress" @Changed="setAddress" @Close="editMode = false">
      </AddressEdit>
    </v-row>
  </v-container>
</template>


<script>
import AddressList from "@/components/Preview/Customer/AddressList.vue";
import AddressEdit from "@/components/Preview/Customer/AddressEdit.vue";

export default {
  name: "CustomerAddresses",
  props: {
    Customer: Object,
  },
  components: {
    AddressList,
    AddressEdit,
  },

  data() {
    return {
      editKey: 1,
      editMode: false,
      editObject: null,
    };
  },

  methods: {
    edit(address) {
      console.log('edit', address)
      this.editObject = Object.assign({}, address);
      this.editKey++;
      this.editMode = true;
    },

    setAddress(updated) {
      if (!this.Customer.DefaultDeliveryAddress || updated.Id == this.Customer.DefaultDeliveryAddress.Id) {
        this.Customer.DefaultDeliveryAddress = updated;
      }
      this.$refs.AddressList.updateItem(updated);
      this.editMode = false;
    },
  },

  computed: {},

  watch: {},
};
</script>


<style lang='scss' scoped></style>